import reducer from './reducers';

import * as ResponsibleUpdateSelectors from './selectors';
import * as ResponsibleUpdateOperations from './operations';
import * as ResponsibleUpdateTypes from './types';

export { ResponsibleUpdateSelectors, ResponsibleUpdateOperations, ResponsibleUpdateTypes };

export default reducer;
